var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mic"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mic_2",
    d: "M8.00016 9.33325C7.44461 9.33325 6.97238 9.13881 6.5835 8.74992C6.19461 8.36103 6.00016 7.88881 6.00016 7.33325V3.33325C6.00016 2.7777 6.19461 2.30547 6.5835 1.91659C6.97238 1.5277 7.44461 1.33325 8.00016 1.33325C8.55572 1.33325 9.02794 1.5277 9.41683 1.91659C9.80572 2.30547 10.0002 2.7777 10.0002 3.33325V7.33325C10.0002 7.88881 9.80572 8.36103 9.41683 8.74992C9.02794 9.13881 8.55572 9.33325 8.00016 9.33325ZM7.3335 13.9999V11.9499C6.17794 11.7944 5.22238 11.2777 4.46683 10.3999C3.71127 9.52214 3.3335 8.49992 3.3335 7.33325H4.66683C4.66683 8.25547 4.99183 9.04159 5.64183 9.69159C6.29183 10.3416 7.07794 10.6666 8.00016 10.6666C8.92238 10.6666 9.7085 10.3416 10.3585 9.69159C11.0085 9.04159 11.3335 8.25547 11.3335 7.33325H12.6668C12.6668 8.49992 12.2891 9.52214 11.5335 10.3999C10.7779 11.2777 9.82238 11.7944 8.66683 11.9499V13.9999H7.3335Z",
    fill: "#9B9B9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMic);
export default __webpack_public_path__ + "static/media/GreyMic.881982dce8e2f96a96a0351fa36a5ea3.svg";
export { ForwardRef as ReactComponent };